import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { useAdminIdleTimeout } from '@/hooks/useAdminIdleTimeout';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

export default function StandaloneProtectedRoute() {
  const { session, isLoading } = useAuth();
  useAdminIdleTimeout();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Return outlet without Layout wrapper for standalone pages
  return <Outlet />;
}